/**
 * ファイル選択ダイアログを表示し、選択されたファイルを返す
 * @param accept 許可するファイル形式（例: '.xlsx,.xls'）
 */
export function openFileDialog(accept) {
    return new Promise((resolve) => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = accept;
        fileInput.style.display = 'none';
        document.body.appendChild(fileInput);
        fileInput.addEventListener('change', () => {
            const file = fileInput.files?.[0] || null;
            fileInput.remove();
            resolve(file);
        });
        // キャンセル時の処理
        fileInput.addEventListener('cancel', () => {
            fileInput.remove();
            resolve(null);
        });
        fileInput.click();
    });
}
